import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';
// import { Link as a } from 'react-router-dom';

//styling
import './popup.css';
import styled from 'styled-components';

const Popup = (props) => {
  console.log(props);
  return (
    <Wrapper className='kura_tm_modalbox opened'>
      <div className='box_inner'>
        <div className='close'>
          <a onClick={props.closeWeb}>
            <AiOutlineClose className='svg sizer' />
          </a>
        </div>
        <div className='description_wrap'>{props.children}</div>
      </div>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 100vh;
  z-index: 15;
  background-color: ${({ theme }) => theme.modal};
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;

  .box_inner {
    background-color: ${({ theme }) => theme.box_inner};
  }
`;

export default Popup;
